<template>
  <div>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
    <div class="container-fluid">
      <div class="p-2 border-bottom border-info">
        <h4 class="text-info font-italic">
          <strong>測定会-参加受付</strong>
        </h4>
      </div>
      <div>
        <b-form-group label="会員番号:">
          <b-form-input
                      id="userId"
                      type="text"
                      size="13"
                      v-model="form.userId"
                      :state="validators.userId"
                      required
                      readonly
                      placeholder="13桁数字を入力">
          </b-form-input>
          <b-form-invalid-feedback id="userIdFeedback">
            13桁数字を入力してください
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="参加測定会:">
          <b-form-input
                      id="groupId"
                      type="text"
                      size="13"
                      v-model="currentUserGroup.name"
                      required
                      readonly
                      placeholder="13桁数字を入力">
          </b-form-input>
        </b-form-group>
        <b-form-group label="ID番号:">
          <b-form-input
                      id="userNo"
                      type="text"
                      size="16"
                      v-model="form.userNo"
                      :state="validators.userNo"
                      required
                      placeholder="ID番号を入力">
          </b-form-input>
          <b-form-invalid-feedback id="userNoFeedback">
            1文字以上を入力してください
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="性別:">
          <b-form-input
                      id="gender"
                      type="text"
                      size="16"
                      v-model="form.gender"
                      required
                      readonly
                      :formatter="formatGender"
                      placeholder="性別を選択">
          </b-form-input>
        </b-form-group>
        <b-form-group label="生年月日:(日付は1日に固定されます)">
          <b-form-input
                      id="birthday"
                      type="text"
                      v-model="form.birthday"
                      required
                      readonly
                      placeholder="">
          </b-form-input>
        </b-form-group>
        <b-form-group label="身長(cm):">
          <b-form-input
                      id="height"
                      type="number"
                      size="10"
                      v-model="form.height"
                      required
                      readonly
                      placeholder="cm">
          </b-form-input>
          <b-form-invalid-feedback id="heightFeedback">
            身長を入力してください
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div>
        <b-button variant="success" @click="onRegister" :disabled="registered">登録</b-button>
      </div>
    </div>
    <hr>
    <div class="mb-2">
      <b-btn variant="secondary" block @click="$router.push('/usergroups/' + $store.getters.currentUserGroup.groupId + '/top')">
        <span>戻る</span>
      </b-btn>
    </div>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'

const logger = new Logger('AppendUser')

export default {
  name: 'AppendUser',
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      registered: false,
      userSettings: {},
      form: {
        userId: null,
        userNo: null,
        groupId: this.$store.getters.currentUserGroup.groupId,
        gender: '1',
        birthday: '1968-01-01',
        height: 165
      },
      validators: {
        userNo: null
      },
      genderOptions: [
        { text: '男性', value: '1' },
        { text: '女性', value: '2' }
      ]
    }
  },
  mounted () {
    this.loadItems()
  },
  computed: {
    currentUserGroup () {
      return this.$store.getters.currentUserGroup
    }
  },
  methods: {
    loadItems (done) {
      this.groupId = this.$route.params['groupId']
      this.userId = this.$route.query['userId']
      this.loading = true
      this.message = null
      this.error = null
      this.$store.dispatch('fetchUser', { userId: this.userId }).then((user) => {
        this.loading = false
        logger.debug('user: ', user)
        this.userSettings = user
        this.form.userId = user.user_id
        this.form.birthday = user.birthday
        this.form.gender = user.gender
        this.form.height = user.heightInCentimeters
        done && done()
      }).catch((error) => {
        this.loading = false
        logger.error(error)
        this.error = '通信エラーが発生しました。'
        this.error += error.message
      })
    },
    refreshItem () {
      this.loadItems()
    },
    formatGender (value, event) {
      return value === '1' ? '男性' : '女性'
    },
    validate () {
      this.validators.userNo = this.form.userNo
      return ['userNo'].every(p => this.validators[p])
    },
    onRegister () {
      this.error = null
      this.message = null
      logger.debug(this.form)
      if (!this.validate()) {
        logger.debug(this.validators)
        return
      }

      let userData = Object.assign({}, this.userSettings)
      let userGroup = Object.assign({}, this.currentUserGroup)

      this.loading = true
      return this.$store.dispatch('createUserDailyEnquetes', { user: userData, userGroup: userGroup, userNo: this.form.userNo }).then(() => {
        this.loading = false
        this.message = '登録しました'
        this.registered = true
        this.validators = {
          userNo: null
        }
        return this.$router.push('/usergroups/' + this.currentUserGroup.groupId + '/users/' + userData.user_id)
      }).catch(err => {
        this.loading = false
        logger.error(err)
        this.error = err.message || err
      })
    }
  }
}
</script>

<style scoped>
.step-table, .users-table {
  font-size: 0.75rem;
}
</style>
